import React from "react";
import "./audit_styles.css";

const AuditChatbotDisplay = ({ node, depth, onToggle }) => {

  return (
    <div className="audit-tree-node" data-depth={depth} data-node-id={node.id}>
      <div className="audit-node-header">
        <button
          className={`audit-expand-button ${
            node.children.length === 0 ? "audit-empty" : ""
          }`}
          onClick={() => node.children.length > 0 && onToggle(node.id)}
        >
          {node.children.length > 0 ? (node.expanded ? "−" : "+") : ""}
        </button>
        <div style={{ flex: 1 }}>
          <div
            className="audit-node-content"
            dangerouslySetInnerHTML={{ __html: node.htmlContent }}
          />
          {node.messages && (
            <div
              style={{
                marginTop: "12px",
                padding: "10px",
                backgroundColor: "#f8f9fa",
                border: "1px solid #dee2e6",
                borderRadius: "4px",
                fontSize: "0.9em"
              }}
            >
              <div style={{ fontWeight: "600", marginBottom: "8px", color: "#495057" }}>
              Custom Messages:
              </div>
              <div style={{ marginBottom: "8px" }}>
                <strong style={{ color: "#007bff" }}>You:</strong>
                <div
                  style={{ marginTop: "4px", marginLeft: "10px", color: "#212529" }}
                  dangerouslySetInnerHTML={{ __html: node.messages.userMessage}}
                />
              </div>
              <div>
                <strong style={{ color: "#28a745" }}>AMI:</strong>
                <div
                  style={{ marginTop: "4px", marginLeft: "10px", color: "#212529" }}
                  dangerouslySetInnerHTML={{ __html: node.messages.amiMessage}}
                />
              </div>
            </div>
          )}
        </div>
      </div>

      {node.children.length > 0 && node.expanded && (
        <div className="audit-node-children">
          {node.children.map((child) => (
            <AuditChatbotDisplay
              key={child.id}
              node={child}
              depth={depth + 1}
              onToggle={onToggle}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default AuditChatbotDisplay;


// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/V2Audit/AuditChatbotDisplay.js